<mat-form-field class="w-100 dense-2" [appearance]="appearance()">
  <mat-label>{{ label() }}</mat-label>
  <input
    matInput
    [placeholder]="placeholder()"
    [formControl]="formControlRef()"
    [required]="required()"
    currencyMask
  />
  <mat-hint>
    <ng-content select="[slot=hint]"> </ng-content>
  </mat-hint>
</mat-form-field>
